import { render, staticRenderFns } from "./MessageLogs.vue?vue&type=template&id=0327ccf8&scoped=true&"
import script from "./MessageLogs.vue?vue&type=script&lang=js&"
export * from "./MessageLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0327ccf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0327ccf8')) {
      api.createRecord('0327ccf8', component.options)
    } else {
      api.reload('0327ccf8', component.options)
    }
    module.hot.accept("./MessageLogs.vue?vue&type=template&id=0327ccf8&scoped=true&", function () {
      api.rerender('0327ccf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/MessageLogs.vue"
export default component.exports